//extracted by mini-css-extract-plugin
export default {"insightsPagination":"DVTable_insightsPagination__aw-y8"};;